var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedAstrologers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6887 50.5588L42.0085 51.8786L44.4896 49.3975",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7038 55.0462L42.8532 56.9994H42.8004L39.9497 55.0462C38.4716 54.0432 37.5742 52.354 37.5742 50.5591V46.4416C37.5742 46.336 37.627 46.2832 37.7326 46.2832H47.9209C48.0265 46.2832 48.0793 46.336 48.0793 46.4416V50.5591C48.0793 52.354 47.1819 54.0432 45.7038 55.0462Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8005 53.9375C44.6081 53.9375 46.0735 52.4721 46.0735 50.6645C46.0735 48.8569 44.6081 47.3916 42.8005 47.3916C40.9929 47.3916 39.5276 48.8569 39.5276 50.6645C39.5276 52.4721 40.9929 53.9375 42.8005 53.9375Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9999 40.5002C47.7529 40.5002 52.4166 35.9297 52.4166 30.2918C52.4166 24.6539 47.7529 20.0835 41.9999 20.0835C36.247 20.0835 31.5833 24.6539 31.5833 30.2918C31.5833 35.9297 36.247 40.5002 41.9999 40.5002Z",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4166 44.5835H53.15C54.673 44.5839 56.1435 45.1294 57.2852 46.1174C58.4269 47.1054 59.1611 48.4679 59.35 49.949L60.1645 56.3272C60.2378 56.9017 60.1855 57.485 60.0112 58.0383C59.8369 58.5916 59.5444 59.1022 59.1533 59.5362C58.7623 59.9703 58.2814 60.3179 57.7428 60.5559C57.2041 60.7939 56.62 60.917 56.0291 60.9168H27.9708C27.3799 60.917 26.7958 60.7939 26.2571 60.5559C25.7185 60.3179 25.2377 59.9703 24.8466 59.5362C24.4555 59.1022 24.1631 58.5916 23.9887 58.0383C23.8144 57.485 23.7621 56.9017 23.8354 56.3272L24.6479 49.949C24.8368 48.4672 25.5717 47.1041 26.7142 46.116C27.8567 45.1279 29.3283 44.5829 30.852 44.5835H31.5833",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedAstrologers);
export default __webpack_public_path__ + "static/media/verified-astrologers.319ea3477f68a3451c1377440577f7f1.svg";
export { ForwardRef as ReactComponent };